import { Button } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const UndoButton = ({ buttonText = 'Undo', clickHandler = () => {} }) => {
  return (
    <Button minimal icon={'reset'} onClick={clickHandler}>
      {buttonText}
    </Button>
  );
};

UndoButton.propTypes = {
  buttonText: PropTypes.string,
  clickHandler: PropTypes.func,
};

export default UndoButton;
